import { gql } from 'graphql-request';

export const CACHE_INVOICE_VOID_QUERY = gql`
  mutation CacheInvoiceVoid($uuid: ID!) {
    invoiceVoid(uuid: $uuid) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        nanoId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
